export function tradingWalletDepositAssetImageGet(
  asset: string | undefined,
): string {
  if (!asset) {
    return "/usd-coin-usdc-logo.svg";
  }

  switch (asset.toLowerCase()) {
    case "usdc":
      return "/images/icons/usdc-icon.svg";
    case "eth":
      return "/images/icons/eth-icon.svg";
    case "sol":
      return "/images/icons/sol-icon.svg";
    case "bnb":
      return "/images/icons/bnb-icon.svg";
    case "usdt":
      return "/images/icons/usdt-icon.svg";
    default:
      return "/usd-coin-usdc-logo.svg";
  }
}
